// Read from window.__ENV__ (served by /env.js) so config is not baked into the
// build — one image runs in every environment.

const env: Partial<RuntimeEnv> = window.__ENV__ ?? {};

export const runtimeEnv: RuntimeEnv = {
  AZURE_CLIENT_ID: env.AZURE_CLIENT_ID ?? '',
  AZURE_TENANT_ID: env.AZURE_TENANT_ID ?? '',
  AZURE_API_SCOPE: env.AZURE_API_SCOPE ?? '',
  AZURE_REDIRECT_URI: env.AZURE_REDIRECT_URI ?? '',
  AZURE_GRAPH_MAIL_SCOPE: env.AZURE_GRAPH_MAIL_SCOPE ?? '',
  AZURE_GRAPH_FILES_SCOPE: env.AZURE_GRAPH_FILES_SCOPE ?? '',
  SHAREPOINT_SITE: env.SHAREPOINT_SITE ?? '',
  SHAREPOINT_REPORTS_FOLDER: env.SHAREPOINT_REPORTS_FOLDER ?? '',
};
